import Vue from 'vue'
import Login from './index.vue'

const LoginComponent = Vue.extend(Login)

Login.install = function (data = {}) {

    let instance = new LoginComponent({ data }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.$on('isShowChange', (isShow) => {
            if (!isShow) {
                document.body.removeChild(instance.$el)
                instance.$destroy()
            }
        })
    })

    return instance
}

// smt登录内容 调整后 可以切换跳转登录和弹窗登录
const smtLogin = (data = {}) => {
    if (window.thirdPartyCookiesEnabled == false) {
        unifiedLoginAndReg(data.dialogSwitch)
    } else {
        Login.install(data)
    }
}

// 跳转登录
function unifiedLoginAndReg(dialogSwitch) {
    let type = ''
    if (dialogSwitch == 1) {
        type = 'register'
    } else {
        type = 'login'
    }
    const siteid = process.env.VUE_APP_SITEID;
    const ht = process.env.VUE_APP_SSOURL;
    const protocol = location.protocol;
    const hq_source = window.hq_source ? '&hq_source=' + window.hq_source : ''
    const hq_source_link = window.hq_source_link ? '&hq_source_link=' + encodeURIComponent(window.hq_source_link) : '';
    // hqsource referer添加
    let $referer = location.href
    if (hq_source) {
        $referer = decodeURIComponent($referer)
        if ($referer.indexOf('?') > -1) {
            $referer = $referer + ("&hq_source=" + window.hq_source) + ("&hq_source_link=" + encodeURIComponent(window.hq_source_link))
        } else {
            $referer = $referer + ("?hq_source=" + window.hq_source) + ("&hq_source_link=" + encodeURIComponent(window.hq_source_link))
        }
        $referer = encodeURIComponent($referer)
    }
    window.location.href = `${protocol}//${ht}/${type}/unified?version=2024${hq_source}${hq_source_link}&referer=${$referer}&siteid=${siteid}#${encodeURIComponent(location.href)}`
}

export default smtLogin
